<!-- Resultado Parcial -->
<div class="timeline-badge">
  <a><em class="fa fa-circle"></em></a>
</div>

<h4 *ngIf="timelineActive">{{ timeline.dataHora | date:'HH:mm'}} <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small></h4>

<div class="timeline-panel" (click)="onClickQuadro()" [ngClass]="{'add-pointer': isFichaResultadoParcial}">
  <div class="step">
    <span class="icon"></span>

    <h2>{{ timeline.tituloStatus }}</h2>

    <span>{{ timeline.subTituloStatus}}</span>

    <div *ngIf="timelineActive && timeline.resultadoParcial && timeline.resultadoParcial.garantias" class="product">
      {{ timeline.resultadoParcial.garantias[0].descMarcaModelo }}<br />{{ timeline.resultadoParcial.garantias[0].anoFabric }}/{{ timeline.resultadoParcial.garantias[0].anoModelo }}
    </div>

    <div *ngIf="timelineActive" class="specifications">
      <div class="col-xs-6">
        <span class="title">Valor financiado</span>

        R$ {{ timeline.resultadoParcial.valorLiquido | number:'1.2-2' }}<br>
        {{ timeline.resultadoParcial.qtdParcelas }}x R$ {{ timeline.resultadoParcial.valorParcela | number:'1.2-2' }}
      </div>

      <div class="col-xs-6">
        <span class="title">Proteções selecionadas</span>
      </div>

      <div class="clear"></div>
    </div>
    <div *ngIf="!timelineActive"><br /></div>
  </div>
</div>
